module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "site"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.sites), function(site, index) {
    return (site.trash !== 1) ? _c('div', {
      key: index,
      staticStyle: {
        "padding": "10px 10px 10px 25px"
      }
    }, [_c('router-link', {
      staticClass: "site_link",
      attrs: {
        "to": _vm.siteTo(index)
      }
    }, [_vm._v(_vm._s(index + 1) + ". " + _vm._s(_vm.showName(site)))])], 1) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "sites": _vm.sites
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "site_pic"
  }, [_c('img', {
    attrs: {
      "src": "/../static/images/u19394.jpg"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c8fc0b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Site.vue
// module id = 1234
// module chunks = 4